/**
 * /admin/audit — Tenant audit explorer (route shell).
 * Screen impl in `./audit-screen.tsx`, lazy-loaded.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/audit')({
  component: lazyRouteComponent(() => import('./audit-screen'), 'AdminAudit'),
});
